import { db } from "../firebase";
import { collection, query, orderBy, getDocs, where } from "firebase/firestore";

//岐阜,熊本、札幌、海外事業、プラント、航空宇宙
const ommitOffices = [1, 5, 17, 35, 40, 46];

export const getdeliveryOfficesRecords = async (str) => {
  try {
    const officesRef = collection(db, "offices");
    const q = query(officesRef, orderBy("A105_mji005.value"));
    //事業所コード:A105_mji010
    // const q = query(
    //   workersRef,
    //   orderBy("A13_カナ検索.value"),
    //   startAt(str),
    //   endAt(str + "\uf8ff")
    // );

    const querySnapshot = await getDocs(q);
    const results = [];
    querySnapshot.forEach((doc) => {
      const record = doc.data();
      if (!ommitOffices.includes(Number(record.A105_mji010.value))) {
        results.push({
          id: {
            id: record.A105_mji010.value,
            bid: record.A105_mji005.value,
            name: record.A105_mji020.value,
            address_main: record.A105_mji060.value,
            address_sub: record.A105_mji070.value,
            tell: record.A105_mji080.value,
          },
          name: record.A105_mji020.value,
        });
      }
    });

    results.sort((a, b) => parseInt(a.id.id) - parseInt(b.id.id));
    const idAbove50 = results.filter((item) => parseInt(item.id.id) >= 50);
    const idBelow50 = results.filter((item) => parseInt(item.id.id) < 50);
    const sortedResults = [...idAbove50, ...idBelow50];
    return sortedResults;
  } catch (error) {
    console.error("Error getting documents: ", error);
  }
};
